import {
  RefractoryMaterialsPage,
  refractoryMaterialsFeatureTranslations
} from '@features/refractory-materials'
import {FeatureTranslationsLoader} from '@hconnect/common/localization-loaders'
import {UpmPlantProvider, useUpmPlant} from '@hconnect/upm'
import {useUrlParam} from '@refra/modules/routing/hooks'

// Dual-run bridge: mounts the migrated @features/refractory-materials inside legacy
// refraplanner, supplying plant context from the legacy plantCode url param.
export const RefraCatalogBridge: React.FC = () => {
  const plantCode = useUrlParam('plantCode')
  const {upmId} = useUpmPlant({plantId: plantCode})

  return (
    <FeatureTranslationsLoader translations={refractoryMaterialsFeatureTranslations}>
      <UpmPlantProvider plantUpmId={upmId}>
        <RefractoryMaterialsPage />
      </UpmPlantProvider>
    </FeatureTranslationsLoader>
  )
}
